import { useEffect, useState } from "react";
import { Heading, Pagination } from "ui-components";

import { JobsCard } from "@/src/app/[locale]/(public)/jobs/components/JobCard";
import {
  JobResponse,
  useJobMemberDashboardJobs,
} from "@/src/hooks/api/generated";

export function LatestJobs(): JSX.Element | null {
  const [page, setPage] = useState(1);
  const { mutate: getJobs } = useJobMemberDashboardJobs();
  const [jobsData, setJobsData] = useState<JobResponse>();

  useEffect(() => {
    getJobs(
      {
        data: {
          page: page || 1,
          pageSize: 2,
        },
      },
      {
        onSuccess: (data) => {
          setJobsData(data);
        },
      }
    );
  }, [getJobs, page]);

  if (!jobsData?.data.length) {
    return null;
  }

  return (
    <div className="flex flex-col gap-y-5">
      <Heading variant="h2">Latest Jobs</Heading>
      <div className="flex justify-center items-center flex-wrap -mx-2.5">
        {jobsData?.data.map((job) => {
          const bannerImage = job.organization.organizationImage.find(
            (img) => img?.image?.type === "banner"
          )?.image?.public_id;

          const logoImage = job.organization.organizationImage.find(
            (img) => img?.image?.type === "logo"
          )?.image?.public_id;

          return (
            <div className="w-full sm:w-1/2 px-2.5" key={job.id}>
              <JobsCard
                city={job.locations.location}
                country={job.locations.country}
                type={job.type}
                coverImageUrl={bannerImage}
                organizationName={job?.organization?.name}
                organizationSlug={job?.organization?.slug}
                logoImageUrl={logoImage}
                id={job.id}
                title={job.title}
                industry={job?.organization?.industry?.name}
                jobSlug={job.slug}
                isFavorite={job.is_favourite}
                sub_brand_name={job.sub_brand_name}
                subBrand={job.subBrand}
              />
            </div>
          );
        })}
      </div>
      {!!jobsData?.total && jobsData?.total > 0 && (
        <div className="mt-0">
          <Pagination
            currentPage={page}
            totalPages={Math.round((jobsData?.total ?? 0) / 2)}
            totalRecords={jobsData?.total ?? 0}
            onPageChange={(newPageNumber) => {
              setPage(newPageNumber);
            }}
          />
        </div>
      )}
    </div>
  );
}
